import React from "react";
import EmergencyProceduresPreviewNav from "./EmergencyProceduresPreviewNav";
import JobShiftEmergencyProceduresDocument from "../../../JobShiftEmergencyProcedures/JobShiftEmergencyProceduresDocument";
import styles from "../PreviewV3.module.css";
export default function EmergencyProceduresPreviewLayout({ procedures, sections = {}, context = {} }) {
  return (
    <div className={styles.PreviewWrap}>
      <EmergencyProceduresPreviewNav procedures={procedures} />
      <main>
        <div className={styles.PreviewDoc} style={{ background: "transparent", border: "none", borderRadius: 0 }}>
          <JobShiftEmergencyProceduresDocument
            procedures={procedures}
            sections={sections}
            context={context}
            embedded
            withNavigationAnchors
          />
        </div>
      </main>
    </div>
  );
}
